import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
//import Checkout from "./components/Checkout";
import AboutUs from "./pages/AboutUs";
import AdminProductos from "./pages/AdminProductos";
import AdminCategorias from "./pages/AdminCategorias";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Product from "./pages/Product";
import Products from "./pages/Products";
import ShoppingCart from "./pages/ShoppingCart";
import { ToastContainer } from "react-toastify";
import ShoppingCartPage from "./pages/ShoppingCartPage";
import AdminUsuarios from "./pages/AdminUsuarios";
import CheckoutControl from "./components/CheckoutControl";
import NotFound from "./pages/NotFound";
import AdminRoute from "./components/AdminRoute";
import LoggedInRoute from "./components/LoggedInRoute";
import Admin from "./pages/Admin";
import AdminOrders from "./pages/AdminOrders";
import UserOrder from "./components/UserOrder";
import Navbar from "./components/Navbar";
import RightTag from "./components/RightTag";
import Thank from "./pages/Thank";
import SocialResponsability from "./components/SocialResponsability";
import PasswordReset from "./pages/PasswordReset";
import React, { useEffect, useState } from "react";
import Faqs from "./pages/Faqs";

function App() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <>
      <BrowserRouter>
        <SocialResponsability show={show} setShow={setShow} />;
        <Navbar />
        <RightTag />
        <Switch>
          <Route exact path="/" component={Home} />
          <AdminRoute path="/admin/productos" component={AdminProductos} />
          <AdminRoute path="/admin/categorias" component={AdminCategorias} />
          <AdminRoute path="/admin/usuarios" component={AdminUsuarios} />
          <AdminRoute path="/admin/ventas" component={AdminOrders} />
          <AdminRoute path="/admin" component={Admin} />
          <Route path="/faqs" component={Faqs} />
          <Route path="/sobre-nosotros" component={AboutUs} />
          <Route path="/contact" component={Contact} />
          <Route path="/ver-pedido" component={ShoppingCartPage} />
          <Route path="/shopping-cart" component={ShoppingCart} />
          <Route path="/productos" component={Products} />
          <Route path="/producto/:slug" component={Product} />
          <Route exact path="/ordenes" component={UserOrder} />
          <Route exact path="/gracias" component={Thank} />
          <Route exact path="/password-reset" component={PasswordReset} />
          <LoggedInRoute path="/verificar" component={CheckoutControl} />
          <Route component={NotFound} />
        </Switch>
        <ToastContainer />
      </BrowserRouter>
    </>
  );
}

export default App;
